import { filesService } from "../../api/files";

export function getFiles(type, id, id2) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      filesService.getFiles(type, id, id2).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function setFiles(type, id, id2, data) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      filesService.setFiles(type, id, id2, data).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function downloadFile(type, fileId) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      filesService.downloadFile(type, fileId).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function openFile(type, fileId) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      filesService.openFile(type, fileId).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}
